import {
  UPLOAD_NOC,
  UPLOAD_NOC_SUCCESS,
  UPLOAD_NOC_ERROR,
  DOWNLOAD_NOC_DOCUMENT,
  DOWNLOAD_NOC_DOCUMENT_SUCCESS,
  DOWNLOAD_NOC_DOCUMENT_ERROR,
  FILTER_NOC_DOCUMENT,
  FILTER_NOC_DOCUMENT_SUCCESS,
  FILTER_NOC_DOCUMENT_ERROR,
  DELETE_NOC_LIST,
  DELETE_NOC_LIST_SUCCESS,
  NOC_API_ERROR_ACTION,
} from "./actionType";

// Initial State
const INIT_STATE = {
  uploading: false,
  uploadResult: { Status: false },

  downloadNocLoading: false,
  documentResult: null,
  documentError: null,

  filterLoading: false,
  filterResult: [],
  filterError: null,

  listBtnLoading: false,
  apiError: null,

  deleteMsg: { Status: false},
};

const UploadNocReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // === Upload ===
    case UPLOAD_NOC:
      return {
        ...state,
        uploading: true,
      };

    case UPLOAD_NOC_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploadResult: action.payload,
      };

    case UPLOAD_NOC_ERROR:
      return {
        ...state,
        uploading: false,
        uploadResult: { Status: false },
      };

    // === Download ===
    case DOWNLOAD_NOC_DOCUMENT:
      return {
        ...state,
        downloadNocLoading: true,
        documentResult: null,
        documentError: null,
      };

    case DOWNLOAD_NOC_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadNocLoading: false,
        documentResult: action.payload,
        documentError: null,
      };

    case DOWNLOAD_NOC_DOCUMENT_ERROR:
      return {
        ...state,
        downloadNocLoading: false,
        documentResult: null,
        documentError: action.payload,
      };
    case FILTER_NOC_DOCUMENT:
      return {
        ...state,
        filterLoading: true,
        filterResult: [],
        filterError: null,
      };

    case FILTER_NOC_DOCUMENT_SUCCESS:
      return {
        ...state,
        filterLoading: false,
        filterResult: action.payload.Data,
        filterError: null,
      };

    case FILTER_NOC_DOCUMENT_ERROR:
      return {
        ...state,
        filterLoading: false,
        filterResult: [],
        filterError: action.payload,
      };

    case DELETE_NOC_LIST:
      return {
        ...state,
        listBtnLoading: true,

      };

    case DELETE_NOC_LIST_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        deleteMsg: action.payload,
        filterResult: state.filterResult.filter(row => row.id !== action.payload.DeletedId),
      };

    case NOC_API_ERROR_ACTION:
      return {
        ...state,
        apiError: action.payload,
      };

    default:
      return state;
  }
};

export default UploadNocReducer;
